(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["solea-favorite-button"] && !Shopify.designMode) return;
  try {
    const key = 'solea:favorites:v1';
  const maxItems = 100;

  function productUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || !url.pathname.includes('/products/')) return null;
      return url.pathname + url.search;
    } catch {
      return null;
    }
  }

  function imageUrl(value) {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.origin);
      return url.protocol === 'https:' || url.origin === window.location.origin ? url.href : null;
    } catch {
      return null;
    }
  }

  function readFavorites() {
    try {
      const raw = JSON.parse(window.localStorage.getItem(key) || '[]');
      if (!Array.isArray(raw)) return [];
      const seen = new Set();
      return raw.filter((item) => {
        if (!item || typeof item !== 'object' || !/^\d{1,30}$/.test(String(item.id)) || typeof item.title !== 'string') return false;
        const url = productUrl(item.url);
        if (!url || seen.has(String(item.id))) return false;
        seen.add(String(item.id));
        item.url = url;
        item.title = item.title.slice(0, 180);
        item.image = imageUrl(item.image);
        return true;
      }).slice(0, maxItems);
    } catch {
      return [];
    }
  }

  function writeFavorites(items) {
    try {
      window.localStorage.setItem(key, JSON.stringify(items.slice(0, maxItems)));
      return true;
    } catch {
      return false;
    }
  }

  function announce(text) {
    let region = document.querySelector('[data-solea-favorites-status]');
    if (!region) {
      region = document.createElement('span');
      region.className = 'solea-favorites__sr';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      region.dataset.soleaFavoritesStatus = '';
      const openDialog = document.querySelector('[data-solea-favorites-dialog][open]');
      (openDialog || document.body).append(region);
    }
    region.textContent = text;
  }

  function renderSurfaces(items) {
    document.querySelectorAll('[data-solea-favorites-count]').forEach((count) => {
      count.textContent = String(items.length);
      count.dataset.empty = String(items.length === 0);
    });
    document.querySelectorAll('[data-solea-favorites-open]').forEach((opener) => {
      opener.setAttribute('aria-label', `${opener.dataset.label} : ${items.length} ${opener.dataset.countLabel}`);
    });
    document.querySelectorAll('[data-solea-favorites-surface]').forEach((surface) => {
      const list = surface.querySelector('[data-solea-favorites-list]');
      if (!list) return;
      list.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('p');
        empty.className = 'solea-favorites__empty';
        empty.textContent = surface.dataset.empty || '';
        list.append(empty);
        return;
      }
      for (const item of items) {
        const card = document.createElement('article');
        card.className = 'solea-favorites__card';
        const link = document.createElement('a');
        link.href = item.url;
        link.className = 'solea-favorites__card-link';
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          image.width = 480;
          image.height = 580;
          link.append(image);
        }
        const title = document.createElement('span');
        title.className = 'solea-favorites__card-title';
        title.textContent = item.title;
        link.append(title);
        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'solea-favorites__remove';
        remove.dataset.soleaFavoriteRemove = String(item.id);
        remove.textContent = surface.dataset.remove || '';
        remove.setAttribute('aria-label', `${surface.dataset.remove || ''} : ${item.title}`);
        card.append(link, remove);
        list.append(card);
      }
    });
  }

  function sync() {
    const items = readFavorites();
    const ids = new Set(items.map((item) => String(item.id)));
    document.querySelectorAll('[data-solea-favorite]').forEach((button) => {
      const saved = ids.has(button.dataset.productId);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? button.dataset.labelRemove : button.dataset.labelAdd} : ${button.dataset.productTitle}`);
      const icon = button.querySelector('.solea-favorite__icon');
      if (icon) icon.textContent = saved ? '♥' : '♡';
    });
    renderSurfaces(items);
  }

  let lastOpener = null;
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const opener = event.target.closest('[data-solea-favorites-open]');
    if (opener) {
      const dialog = document.querySelector('[data-solea-favorites-dialog]');
      if (dialog && !dialog.open) {
        lastOpener = opener;
        sync();
        dialog.showModal();
        dialog.querySelector('[data-solea-favorites-close]')?.focus();
      }
      return;
    }
    const closer = event.target.closest('[data-solea-favorites-close]');
    if (closer) {
      closer.closest('[data-solea-favorites-dialog]')?.close();
      return;
    }
    const button = event.target.closest('[data-solea-favorite]');
    if (button) {
      const id = button.dataset.productId;
      const url = productUrl(button.dataset.productUrl);
      if (!/^\d{1,30}$/.test(id || '') || !url) return;
      const items = readFavorites();
      const index = items.findIndex((item) => String(item.id) === id);
      if (index >= 0) items.splice(index, 1);
      else items.unshift({ id, title: (button.dataset.productTitle || '').slice(0, 180), url, image: imageUrl(button.dataset.productImage) });
      if (!writeFavorites(items)) {
        announce(button.dataset.labelError || '');
        return;
      }
      sync();
      announce(button.getAttribute('aria-label') || '');
      return;
    }
    const remove = event.target.closest('[data-solea-favorite-remove]');
    if (!remove) return;
    const items = readFavorites().filter((item) => String(item.id) !== remove.dataset.soleaFavoriteRemove);
    const surface = remove.closest('[data-solea-favorites-surface]');
    if (!writeFavorites(items)) {
      announce(surface?.dataset.storageError || '');
      return;
    }
    sync();
    announce(surface?.dataset.removed || '');
  });

  document.addEventListener('close', (event) => {
    if (event.target instanceof Element && event.target.matches('[data-solea-favorites-dialog]')) lastOpener?.focus();
  }, true);

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', sync);
  window.addEventListener('storage', (event) => { if (event.key === key) sync(); });
  if (document.readyState !== 'loading') sync();
  } catch(e) { console.error(e); }
})();

})();
